document.addEventListener('DOMContentLoaded', function () {
  let pageUrl = new URL(window.location.href);
  let pageParams = pageUrl.searchParams;
  let paramTargetElement = '';
  if (pageParams.get('target') && document.getElementById(pageParams.get('target')) != null) {
    paramTargetElement = document.getElementById(pageParams.get('target'));
    scrollToTarget(paramTargetElement);
  }

  const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {
      e.preventDefault();
      let href = smoothScrollTrigger[i].getAttribute('href');
      let clickTargetElement = document.getElementById(href.replace('#', ''));
      scrollToTarget(clickTargetElement);
    });
  }

  function scrollToTarget(targetElement) {
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    let adjust = 112.5;
    const windowWidth = window.outerWidth;
    if (windowWidth <= 999) {
      adjust = 81.11;
    }
    const target = rect + offset - adjust;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  }

  const now = new Date();
  const target = new Date('2025-11-26T20:00:00');
  if (now > target) {
    document.querySelector('.novelty-tabloid-sections.coming-soon').remove();
    document.querySelector('.novelty-tabloid-sections.published').style.display = 'block';
  } else {
    document.querySelector('.novelty-tabloid-sections.coming-soon').style.display = 'block';
    document.querySelector('.novelty-tabloid-sections.published').remove();
  }

  if (document.querySelector('.novelty-item__carousel .swiper') != null) {
    new Swiper('.novelty-item__carousel .swiper', {
      loop: true,
      slidesPerView: 1,
      // spaceBetween: '2.5%',
      // autoHeight: true,
      speed: 1800,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  // すべての fade-slider を対象に、それぞれ独立してフェードさせる
  const fadeSliders = document.querySelectorAll('.fade-slider');
  fadeSliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.fade-slide');
    if (slides.length === 0) return;

    let current = 0;
    slides[current].classList.add('is-active');

    setInterval(() => {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 3000); // 3秒ごとに切り替え
  });
});
